(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-dual-slider-parallax"] && !Shopify.designMode) return;
  try {
    

// INIT SLIDER
function initCustomSlider() {
  if (typeof $ !== 'undefined' && typeof $.fn.slick === 'function') {

    if ($('.custom-slider-main').hasClass('slick-initialized')) {
      $('.custom-slider-main').slick('unslick');
      $('.custom-slider-nav').slick('unslick');
    }

    // TOP (FADE)
    $('.custom-slider-main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: true,
      asNavFor: '.custom-slider-nav'
    });

    // BOTTOM (SLIDE)
    $('.custom-slider-nav').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.custom-slider-main',
      dots: false,
      arrows: true,
      centerMode: true,
      centerPadding: '11.81vw',
      focusOnSelect: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '35.4vw',
            infinite: true,
            arrows: true
          }
        },
         {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '90px',
            infinite: true,
            arrows: true
          }
        }
      ]
    });
  }
}

// PARALLAX (SUBTLE)
function initParallaxSlides() {
  const slides = document.querySelectorAll('.custom-slider-main .main-slide');
  if (!slides.length) return;

  window.addEventListener('scroll', function () {
    slides.forEach(slide => {
      const rect = slide.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.top < windowHeight && rect.bottom > 0) {

        const centerOffset = rect.top + rect.height / 2 - windowHeight / 2;

        // subtle movement
        const movement = centerOffset * 0.03;

        slide.style.backgroundPosition = `center calc(50% + ${movement}px)`;
      }
    });
  });
}

// INIT
document.addEventListener('DOMContentLoaded', function() {
  initCustomSlider();
  initParallaxSlides();
});

document.addEventListener('shopify:section:load', function() {
  initCustomSlider();
  initParallaxSlides();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
function initCustomSlider() {
  if (typeof $ !== 'undefined' && typeof $.fn.slick === 'function') {
    if ($('.custom-slider').hasClass('slick-initialized')) {
      $('.custom-slider').slick('unslick');
    }

    $('.custom-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true, 
      centerPadding: '10.4vw',
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000,
       responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '90px'
          }
        }
      ]
    });
  }
}

function initParallax() {
  const section = document.querySelector('.custom-slider-section');
  if (!section) return;

  const initialPos = 50;
  const maxOffset = 30;

  window.addEventListener('scroll', function () {
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.bottom > 0 && rect.top < windowHeight) {
      const scrollPercent = ((rect.top + rect.height / 2) - windowHeight / 2) / (windowHeight / 2);
      const offset = -scrollPercent * maxOffset;
      section.style.backgroundPosition = `center calc(${initialPos}% + ${offset}px)`;
    }
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  initCustomSlider();
  initParallax();
});

// Initialize when Shopify sections reload
document.addEventListener('shopify:section:load', function() {
  initCustomSlider();
  initParallax();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-banner-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sliderWrapper = document.querySelector('.multi-banner-section .slider');

  if (sliderWrapper && typeof $ !== 'undefined' && typeof $.fn.slick === 'function') {
    $(sliderWrapper).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 750, settings: { slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '90px' } }
      ]
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
